import { getCurrentUser } from '@guuru/firebase-web';
import {
  client as Client,
  errorMessage,
  errorCode,
  errorType,
} from '@guuru/graphql-common';
import fragments from '../fragments';
import errorCallback from './errors';
import sha256Fn from './sha';
import tracingHeaders from './tracing';

const client = Client({
  getCurrentUser,
  errorCallback,
  tracingHeaders,
  sha256Fn,
  fragments,
});

export { client, errorCode, errorMessage, errorType };
